import AbstractModel from '../AbstractModel';

class EquipmentProjectCategoryModel extends AbstractModel {}

export default EquipmentProjectCategoryModel;
